import React, { useState, useEffect } from "react";
function App() {
  let [todo, todofun] = useState("");
  let [todo2, todofun2] = useState([]);
  useEffect(() => {
    // Retrieve todo items from localStorage
    const storedTodos = localStorage.getItem("todos");

    if (storedTodos) {
      todofun2(JSON.parse(storedTodos));
    }
  }, []);

  const date = new Date().toLocaleString().split(",")[0];

  function handlechange(e) {
    let newvalue = e.target.value;
    todofun(newvalue);
  }

  function clickToAddToDo() {
    const newTodos = [...todo2, todo];

    // Store new todo items in localStorage
    localStorage.setItem("todos", JSON.stringify(newTodos));

    todofun2(newTodos);
    todofun("");
  }
  function removetodo(index) {
    const newTodos = [...todo2];
    newTodos.splice(index, 1);

    // Store updated todo items in localStorage
    localStorage.setItem("todos", JSON.stringify(newTodos));
    todofun2(newTodos);
  }
  return (
    <div className="container">
      <div className="heading">
        <h1>To-Do List</h1>
      </div>
      <div className="form">
        <input type="text" value={todo} onChange={handlechange} />
        <button onClick={clickToAddToDo}>
          <span>Add</span>
        </button>
      </div>
      <div>
        {todo2?.length > 0 ? (
          <ul>
            {todo2.map((e, index) => {
              console.log(index);
              return (
                <div className="todo" key={index}>
                  <li>
                    {e} , {date}
                  </li>
                  <button onClick={() => removetodo(index)}>remove</button>
                </div>
              );
            })}
          </ul>
        ) : (
          <h2>No tasks found </h2>
        )}
      </div>
    </div>
  );
}
export default App;
